// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1qtvH","inner":"Footer_inner__3PlpR","nextIcon":"Footer_nextIcon__39ZhV","innerLeft":"Footer_innerLeft__3P8W7"};